export const SettingsLabel = label => ({
  label,
  settingType: 'settingsLabel',
})

export const PanelLabel = ({ label }) => (
  <h3 className="panel--section-title settings--label">{label}</h3>
)